// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3N4c8","item":"PaymentsMobile_item__36AVX","label":"PaymentsMobile_label__bIp1Z","amount":"PaymentsMobile_amount__Eus1T"};